'use client';
import { useEffect } from 'react';

 import Header from'@/components/common/Header';
 import Footer from'@/components/common/Footer';
 import HeroSection from'./components/HeroSection';
 import ServicesBentoGrid from'./components/ServicesBentoGrid';
 import IndustriesShowcase from'./components/IndustriesShowcase';
 import WhyChooseUs from'./components/WhyChooseUs';
 import CTASection from'./components/CTASection';

export default function Homepage() {
  useEffect(() => {
    const reveals = document.querySelectorAll('.reveal')
    if (!reveals?.length) return

    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add('active')),
      { threshold: 0.1 }
    )
    reveals?.forEach((el) => observer?.observe(el))

    return () => observer?.disconnect();
  }, [])

  return (
    <>
      <Header />
      <main className="pt-28 sm:pt-24 md:pt-20">
        <HeroSection />
        <ServicesBentoGrid />
        <IndustriesShowcase />
        <WhyChooseUs />
        <CTASection />
      </main>
      <Footer />
    </>
  )
}